import PropTypes from "prop-types"

import SharedMarkdown from "shared/components/shared_markdown"

import "./selected_service_view.scss"

const StepList = ({ stepType, steps }) => {
  return steps[stepType].length ? (
    <ul>
      {steps[stepType].map((step, index) => {
        return (
          <li key={index}>
            <div styleName="title">{step.name}</div>
            <div styleName="description">
              <SharedMarkdown source={step.description} />
            </div>
          </li>
        )
      })}
    </ul>
  ) : (
    <p styleName="note">There are no {stepType} for this service</p>
  )
}

StepList.propTypes = {
  stepType: PropTypes.oneOf(["triggers", "actions", "queries"]).isRequired,
  steps: PropTypes.object.isRequired,
}

export default StepList
